import React, { useEffect, useState } from 'react';
import Input from '../Input';
import PasswordInput from '../PasswordInput';
import Modal from '../Modal';
import { useConfirm } from '../ConfirmContext';
import * as validation from '../Validation';

import { ReactComponent as CloseIcon } from '../images/x.svg';

const AdminModal = ({setVisible, admin, saveAdmin}) => {
  const confirm = useConfirm();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  useEffect(() => {
    if (admin) {
      setName(admin.name);
      setEmail(admin.email);
    }
  }, [admin]);

  const create = async () => {
    if (validation.getNameWarning(name)) {
      await confirm('Please use a valid name', true);
      return;
    }
    if (validation.getEmailWarning(email)) {
      await confirm('Please enter a valid email address', true);
      return;
    }
    if (validation.getPasswordWarning(password, null)) {
      await confirm('Please enter a valid password', true);
      return;
    }
    if (validation.getPasswordWarning(confirmPassword, password)) {
      await confirm('Please confirm your password correctly', true);
      return;
    }

    saveAdmin(admin?.index, {name,
                             email,
                             password});
    setVisible(false);
  }

  return (
    <Modal isOpen={true}
           zIndex={100}>
      <div style={{
             background: 'linear-gradient(gray, transparent)',
             zIndex: '101',
             position: 'absolute',
             transform: 'translate(-50%, -50%)',
             top: '50%',
             left: '50%',
             width: '600px',
             borderRadius: '10px',
           }}>
        <div
          style={{
            margin: '1px',
            borderRadius: '10px',
            zIndex: '101',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            padding: '20px',
            backgroundColor: 'black',
          }}>
          <div style={{
                 display: 'flex',
                 flexDirection: 'row',
                 alignItems: 'center',
                 justifyContent: 'space-between',
                 width: '100%',
               }}>
            <span style={{fontSize: '22px',
                          fontWeight: 'bold',
                         }}>
              {admin ? 'Edit Admin' : 'Add Admin'}
            </span>

            <CloseIcon className='image'
                       style={{width: '15px',
                               height: '15px',
                               fill: 'white',
                              }}
                       onClick={() => setVisible(false)} />
          </div>

          <Input label='NAME'
                 value={name}
                 onChange={(e) => setName(e.target.value)} />

          <Input label='EMAIL'
                 value={email}
                 onChange={(e) => setEmail(e.target.value)} />

          <PasswordInput label='PASSWORD'
                         onChange={(e) => setPassword(e.target.value)}
                         showWarning={true}/>

          <PasswordInput label='CONFIRM PASSWORD'
                         target={password}
                         onChange={(e) => setConfirmPassword(e.target.value)}
                         showWarning={true}/>

          <div style={{display: 'flex',
                       flexDirection: 'row',
                       alignItems: 'center',
                       marginTop: '10px',
                       gap: '10px',
                       justifyContent: 'center',
                      }}>
            <div style={{alignItems: 'center',
                         padding: '10px 20px',
                         border: '1px solid #e0e0e0',
                         borderRadius: '5px',
                         cursor: 'pointer',
                         fontWeight: 'bold',
                         alignSelf: 'flex-end',
                         display: 'flex',
                         justifyContent: 'center',
                        }}
                 onClick={() => setVisible(false)}>
              Cancel
            </div>
            <div style={{alignItems: 'center',
                         padding: '10px 20px',
                         backgroundColor: '#009de6',
                         color: 'white',
                         borderRadius: '5px',
                         cursor: 'pointer',
                         fontWeight: 'bold',
                         alignSelf: 'flex-end',
                         display: 'flex',
                         justifyContent: 'center',
                        }}
                 onClick={() => create()}>
              {admin ? 'Save' : 'Add'}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default AdminModal;
